import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { useBags } from './hooks/useBags';
import type { BagFilter } from './types';
import { BagCard } from './components/BagCard';
import { BagListTabs } from './components/BagListTabs';
import { BagSearchInput } from './components/BagSearchInput';
import { BagDetailModal } from './components/BagDetailModal';

export const SacolinhasPage = () => {
  const [filter, setFilter] = useState<BagFilter>('abertas');
  const [search, setSearch] = useState('');
  const [params, setParams] = useSearchParams();

  const selectedBagId = params.get('bag') ?? null;

  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } = useBags({
    filter,
    search,
  });

  const bags = data?.pages.flat() ?? [];

  const handleBagClick = (bagId: string) => {
    setParams({ bag: bagId });
  };

  const handleModalClose = () => {
    setParams({});
  };

  return (
    <div className="flex flex-col gap-4 p-6">
      <div className="flex items-center gap-2">
        <ShoppingBag className="h-6 w-6 text-primary" />
        <h1 className="text-2xl font-bold">Sacolinhas</h1>
      </div>

      <BagSearchInput value={search} onChange={setSearch} />
      <BagListTabs filter={filter} onFilterChange={setFilter} />

      <div className="flex flex-col gap-2">
        {isLoading ? (
          <>
            <Skeleton className="h-20 w-full rounded-lg" />
            <Skeleton className="h-20 w-full rounded-lg" />
            <Skeleton className="h-20 w-full rounded-lg" />
          </>
        ) : bags.length === 0 ? (
          <div className="flex flex-col items-center gap-2 py-16 text-muted-foreground">
            <ShoppingBag className="h-10 w-10 opacity-30" />
            <p>Nenhuma sacolinha por aqui.</p>
          </div>
        ) : (
          bags.map((bag) => (
            <BagCard key={bag.id} bag={bag} onClick={handleBagClick} />
          ))
        )}
      </div>

      {hasNextPage && (
        <div className="flex justify-center">
          <Button
            variant="outline"
            onClick={() => fetchNextPage()}
            disabled={isFetchingNextPage}
          >
            {isFetchingNextPage ? 'Carregando...' : 'Carregar mais'}
          </Button>
        </div>
      )}

      <BagDetailModal bagId={selectedBagId} onClose={handleModalClose} />
    </div>
  );
};
